import { FC } from 'react';
import * as React from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

import PdpSharedShippingInfoWrapper from '../PdpSharedShippingInfo/PdpSharedShippingInfoWrapper';
import { PdpSharedDetailShipsFrom } from './PdpSharedDetailShipsFrom';

import styles from './PdpSharedDetail.scss';

import { PdpSharedDetailShipping_item$data as ItemType } from './__generated__/PdpSharedDetailShipping_item.graphql';
import { PdpSharedDetailShipping_user$data as UserType } from './__generated__/PdpSharedDetailShipping_user.graphql';

type Props = {
    item: ItemType;
    user: UserType;
    itemId?: string;
    userId?: string;
    currency: string;
    displayInline: boolean;
    preLinkQuoteDetails: React.ReactNode;
    postLinkQuoteDetails: React.ReactNode;
    isClient: boolean;
    postLinkNoQuoteDetails: React.ReactNode;
    itemQuantity?: number;
};

export const PdpSharedDetailsShippingComponent: FC<Props> = ({
    item,
    currency,
    user,
    displayInline,
    preLinkQuoteDetails,
    postLinkQuoteDetails,
    postLinkNoQuoteDetails,
    isClient,
    itemQuantity,
}) => {
    const leadTime = item?.attributes?.leadTime?.[0]?.option?.urlLabel;

    return (
        <span className={styles.shippingInfoContainer}>
            <PdpSharedShippingInfoWrapper
                user={user}
                item={item}
                currency={currency}
                leadTime={leadTime || ''}
                renderTooltip
                showCustomsInfo
                isClient={isClient}
                displayInline={displayInline}
                preLinkQuoteDetails={preLinkQuoteDetails}
                postLinkQuoteDetails={postLinkQuoteDetails}
                postLinkNoQuoteDetails={postLinkNoQuoteDetails}
                itemQuantity={itemQuantity}
            />
            <PdpSharedDetailShipsFrom item={item} />
        </span>
    );
};

export const PdpSharedDetailShipping = createFragmentContainer(PdpSharedDetailsShippingComponent, {
    user: graphql`
        fragment PdpSharedDetailShipping_user on User {
            ...PdpSharedShippingInfoWrapper_user
        }
    `,
    item: graphql`
        fragment PdpSharedDetailShipping_item on Item {
            ...PdpSharedShippingInfoWrapper_item
            ...PdpSharedDetailShipsFrom_item
            ...ShippingDetailsCustomsDisclaimer_item
            attributes {
                leadTime {
                    option {
                        urlLabel
                    }
                }
            }
        }
    `,
});
